<script>
import CustomButton from '@/components(new)/UI/Buttons/CustomButton/CustomButton.vue'
import '@/scss/_utilities.scss'

export default {
  components: {
    CustomButton
  },
  props: {
    proximaPaginaRouter: {
      typeof: String,
      required: false
    },
    ultimaEtapa: {
      typeof: Boolean,
      default: false
    }
  },
  methods: {
    irParaListagem () {
      this.$router.push({ name: 'listagem-cadastros' })
    },
    salvar () {
      alert('atribuir funcionalidade')
    },
    irParaProximaEtapa () {
      this.$router.push({ name: this.proximaPaginaRouter })
    },
    finalizar () {
      alert('atribuir funcionalidade')
    }
  }
}
</script>

<template>
  <div class="flex-between mt-3 mb-3 ml-3 mr-3">
    <CustomButton
      text="Cancelar" type="IconButton"
      @click="() => irParaListagem()"
    />
    <div>
      <CustomButton text="Salvar" type="OutlinedButton" @click="() => salvar()" />
      <CustomButton
        :text="!ultimaEtapa ? 'Próximo' : 'Finalizar'"
        :icon="!ultimaEtapa ? 'el-icon-plus' : ''"
        @click="() => ultimaEtapa ? finalizar() : irParaProximaEtapa()"
      />
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/components(new)/UI/Buttons/ButtonsFinais/ButtonsFinais.vue